import { updateObjectState } from "../../utils/updateObjectStates"
import { validateMobileNumber, validateEmail } from "./validators";
import { getOtpForMobile, getOtpForEmail,verifyNewUserForMobile, verifyNewUserForEmail,verifyOtpForMobile,verifyOtpForEmail } from "../../services/apiService"

export const handleUserInput = (setUserInputState, value, key) => {
    if (key === 'userSelectedInput') {
        if(value === 'mobileNumber') {
            setUserInputState((prevState)=>{ return updateObjectState(key, value, prevState)})
            setUserInputState((prevState)=>{ return updateObjectState('email', '', prevState)})
        }
        else if(value === 'email') {
            setUserInputState((prevState)=>{ return updateObjectState(key, value, prevState)})
            setUserInputState((prevState)=>{ return updateObjectState('mobileNumber', '', prevState)})
        }  
        return
    }
    setUserInputState((prevState)=>{ return updateObjectState(key, value, prevState)})
    return
    
}

export const handleRequestOtpClick = async (userInputState, setDisplayOtpVerification, setUserInputState) => {
    let handlerResponse = {
        errorMessage : '' ,
        status : true ,
    }

    if(userInputState.userSelectedInput === 'mobileNumber') {
       if(!validateMobileNumber(userInputState.mobileNumber)){
        handlerResponse.errorMessage = 'Invalid Mobile Number'
        handlerResponse.status = false
            return handlerResponse
       }
       let response = await getOtpForMobile(userInputState.mobileNumber)
       if(!response.status) {
        handlerResponse.errorMessage = response.error.msg
        handlerResponse.status = response.status
        return handlerResponse
       }
       setUserInputState((prevState)=>{ return updateObjectState('newUser', response.data.register, prevState)})
       setDisplayOtpVerification(true)
       return response
    } 
    if(userInputState.userSelectedInput === 'email') {
        if(!validateEmail(userInputState.email)){
        handlerResponse.errorMessage = 'Invalid Email'
        handlerResponse.status = false
        return handlerResponse
        }
        let response = await getOtpForEmail(userInputState.email)
        if(!response.status) {
            handlerResponse.errorMessage = response.error.msg
            handlerResponse.status = response.status
            return handlerResponse
        }
        setUserInputState((prevState)=>{ return updateObjectState('newUser', response.data.register, prevState)})
        setDisplayOtpVerification(true)
        return response
    }

    //Super Fetch to login api
    //Handling Response
    //setDisplayOtpVerification(true)
}

export const handleOtpBackButton = (setDisplayOtpVerification) => {
    setDisplayOtpVerification(false)
}

export const handleOtpSubmission = async (code, userInputState, setUserInputState, setUserAuth, history) => {
    // Validate code > all numbers and greater than 6
    let response;
    if(code.length === 6) {
        if (userInputState.newUser) {
            if (userInputState.userSelectedInput === 'email') {
                response = await verifyNewUserForEmail(userInputState.email, code)
            } else {
                response = await verifyNewUserForMobile(userInputState.mobileNumber, code)
                if (response.status) {
                    setUserInputState((prevState)=>{ return updateObjectState('mobileOtp', code, prevState)})
                }
            }
            
            if (response.status) {
                history.push('/new/signup')
            }
        } else {
            if (userInputState.userSelectedInput === 'email') {
                response = await verifyOtpForEmail(userInputState.email, code)
            } else {
                response = await verifyOtpForMobile(userInputState.mobileNumber, code)
                if (response.status) {
                    setUserInputState((prevState)=>{ return updateObjectState('mobileOtp', code, prevState)})
                }
            }

            if(response.status){
                setUserAuth({
                    rydeSendToken: response.data.rydeSendToken,
                    firstName: response.data.firstName,
                    email: response.data.email,
                    mobileNumber: response.data.mobileNumber,
                    memberType: "",

                })
                history.push('/new/booking')
                return response
            }
        }
       
       return response
    } 
}